



















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import { Prop } from 'vue-property-decorator'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { BasicCampaignCollectionModel } from '@/modules/base-campaign/models/base-campaign-collection.model'
import { baseCampaignsTableColumn } from '@/modules/base-campaign/models/columns/base-campaigns-table.column'
import BaseCampaignsTableRow from '@/modules/base-campaign/components/shared/table/BaseCampaignsTableRow.vue'

@Component({
  components: {
    SimpleHeader,
    TesTable
  }
})
export default class CampaignSection extends Vue {
  @Prop({ default: 'campaign' }) icon: string
  @Prop({ default: false }) noHeader: boolean
  @Prop({ default: '' }) headerText: string
  @Prop({ required: true }) tableData: BasicCampaignCollectionModel[]
  @Prop({ default: () => ({}) }) tableProps: object

  protected tableColumns = baseCampaignsTableColumn()

  protected tableRowComponent = BaseCampaignsTableRow
}
